import { localized, msg } from "@lit/localize";
import { BaseExtraButton } from "@whilecat/core/editors/buttons/base-extra-button.js";
import { customElement, property } from "lit/decorators.js";
import { noop } from "lodash";

@localized()
@customElement("view-button")
export class ViewButton extends BaseExtraButton {
    @property() viewButtonCallBack: () => void = noop;

    constructor() {
        super("eye", "eye-fill", msg("Full View"), msg("Partial view"));
    }

    onClicked() {
        super.setToggled(!super.isToggled());

        this.viewButtonCallBack();
    }
}
